import React, { useEffect, useState } from 'react';
import axios from '../services/api';

const CandidateDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/jobs');
        setJobs(response.data.jobs);
      } catch (err) {
        console.error('Error fetching jobs:', err);
      }
    };

    const fetchApplications = async () => {
      try {
        const response = await axios.get('/applications');
        setApplications(response.data.applications);
      } catch (err) {
        console.error('Error fetching applications:', err);
      }
    };

    fetchJobs();
    fetchApplications();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">Candidate Dashboard</h1>

      {/* Applied Jobs */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-royal-blue mb-4">Applied Jobs</h2>
        <ul>
          {applications.length > 0 ? (
            applications.map((application) => (
              <li key={application.id} className="mb-2">
                <p>{application.job.title} - {application.status}</p>
              </li>
            ))
          ) : (
            <p>No applications found.</p>
          )}
        </ul>
      </div>

      {/* Available Jobs */}
      <div>
        <h2 className="text-2xl font-bold text-royal-blue mb-4">Available Jobs</h2>
        <ul>
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <li key={job.id} className="mb-2">
                <p>{job.title} - {job.location}</p>
              </li>
            ))
          ) : (
            <p>No jobs available.</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default CandidateDashboard;